export const searchNode = process.env.SEARCH_NODE_URL;

export const trackJs = 'https://cdn.trackjs.com/agent/v3/latest/t.js';

export const googleRecaptcha = 'https://www.google.com/recaptcha/api.js';

export const googlePublisherTag = 'https://www.googletagservices.com/tag/js/gpt.js';

export const googleApi = 'https://apis.google.com/js/api.js';

export const googleAnalytics = 'https://www.google-analytics.com/analytics.js';

export const googleTagManager = 'https://www.googletagmanager.com/gtm.js';

export const easypack = 'https://geowidget.easypack24.net/js/sdk-for-javascript.js';

export const targeo = 'https://mapa.targeo.pl/Targeo.html?f=TargeoMapInitialize&vn=2_5&k=NzI0NGQ1MzY0NTJhNzFjNDZjYjU0NzRmNmFiNTZhNGY2Mjk5MGQ1NA==&m=1';

export const syte = 'https://cdn.syteapi.com/assets/imajs/imajs.js?a=8784&sig=5f10107fb1857e524c768ba0&languageCode=pl_PL';
